export default class {
    static LOGIN_INVALID = 13;
    static REGISTER_DATA_INVALID = 2001;
    static REGISTER_EMAIL_EXIST = 'Request failed with status code 409';

    static RESTORE_PASS_INVALID_DATA = 3001;
    static RESTORE_PASS_EMAIL_NOT_FOUND = 3002;
    static RESTORE_PASS_SAVE_INVALID_DATA = 3003;
    static RESTORE_PASS_SAVE_INVALID_TOKEN = 3004;
    static RESTORE_PASS_SAVE_INVALID_PASS = 3005;

    static USER_UNAUTHORIZED_ERROR = 'Unauthorized';

    static SESSION_EXPIRED_ERROR = 3;
    static USER_NOT_LOGGED = 4;
}
